import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'utils/queryKeys';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';
import { useMemo } from 'react';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentId } from 'components/editor/grid/reduxStore/documentSettingsSlice';

export function useDocumentImageLibrary(documentId: string, enabled = true) {
  const contentId = useAppSelector(selectContentId);

  const mutationFnToUse = useMemo(() => {
    return () => apiDocumentServiceRepository.getDocumentLibraryImages(contentId);
  }, [contentId, documentId]);

  const { data, isError, isFetched, refetch } = useQuery({
    queryKey: QueryKeys.documentImageLibraryImages(documentId),
    queryFn: mutationFnToUse,
    enabled,
  });
  const result = !data ? [] : data;
  return {
    isError,
    isFetched,
    refetch,
    result,
  };
}
